import { createActions, createReducer } from 'reduxsauce'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  initializePaymentRequest: ['amount', 'bookingId', 'listingId'],
  initializePaymentSuccess: ['payment'],
  initializePaymentFailure: ['error'],
  clearPaymentInitialization: null,
  fetchingMyPaymentsRequest: ['options'],
  fetchingMyPaymentsSuccess: ['result'],
  fetchingMyPaymentsFailure: ['error'],
})

export const PaymentsTypes = Types
export const PaymentsActions = Creators

/* ------------- Initial State ------------- */
const INITIAL_STATE = {
  initializingPayment: false,
  paymentInitialization: null,
  paymentInitializationError: null,
  gettingMyPayments: false,
  myPaymentsSuccess: null,
  getMyPaymentsError: null,
}

/* ------------- Reducers ------------- */
const initializePaymentRequest = (state) => ({
  ...state,
  initializingPayment: true,
  paymentInitialization: null,
  paymentInitializationError: null,
})

const initializePaymentSuccess = (state, action) => ({
  ...state,
  initializingPayment: false,
  paymentInitialization: action.payment,
  paymentInitializationError: null,
})

const initializePaymentFailure = (state, action) => ({
  ...state,
  initializingPayment: false,
  paymentInitialization: null,
  paymentInitializationError: action.error,
})

const clearPaymentInitialization = (state) => ({
  ...state,
  initializingPayment: false,
  paymentInitialization: null,
  paymentInitializationError: null,
})

const fetchingMyPaymentsRequest = (state) => ({
  ...state,
  gettingMyPayments: true,
  myPaymentsSuccess: null,
  getMyPaymentsError: null,
})

const fetchingMyPaymentsSuccess = (state, action) => ({
  ...state,
  gettingMyPayments: false,
  myPaymentsSuccess: action.result,
  getMyPaymentsError: null,
})

const fetchingMyPaymentsFailure = (state, action) => ({
  ...state,
  gettingMyPayments: false,
  myPaymentsSuccess: null,
  getMyPaymentsError: action.error,
})

/* ------------- Hook Types to Reducers ------------- */
export default createReducer(INITIAL_STATE, {
  [Types.INITIALIZE_PAYMENT_REQUEST]: initializePaymentRequest,
  [Types.INITIALIZE_PAYMENT_SUCCESS]: initializePaymentSuccess,
  [Types.INITIALIZE_PAYMENT_FAILURE]: initializePaymentFailure,
  [Types.CLEAR_PAYMENT_INITIALIZATION]: clearPaymentInitialization,
  [Types.FETCHING_MY_PAYMENTS_REQUEST]: fetchingMyPaymentsRequest,
  [Types.FETCHING_MY_PAYMENTS_SUCCESS]: fetchingMyPaymentsSuccess,
  [Types.FETCHING_MY_PAYMENTS_FAILURE]: fetchingMyPaymentsFailure,
})